<template>
	<AppSubmenu class="layout-menu custom-scrollbar" :items="model" :menuMode="menuMode" :menuActive="active" :root="true" :parentMenuItemActive="true" :mobileMenuActive="mobileMenuActive" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"/>
  <div class="copyright-outer mt-auto" style="background-color: #ffffff;">
    <div class="copyright-inner">
      <div>
        <img src="/assets/images/samruddh-logo.png" @dragstart.prevent
        @contextmenu.prevent height="50" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import AppSubmenu from './AppSubmenu';

export default {
  name: 'AppMenu',
  emits: ['menu-click', 'menuitem-click', 'root-menuitem-click'],
  props: {
    model: Array,
    menuMode: String,
    active: Boolean,
    mobileMenuActive: Boolean,
  },
  components: {
    'AppSubmenu': AppSubmenu,
  },
  methods: {
    onMenuClick(event) {
      this.$emit('menu-click', event);
    },
    onMenuItemClick(event) {
      this.$emit('menuitem-click', event);
    },
    onRootMenuItemClick(event) {
      this.$emit('root-menuitem-click', event);
    },
  },
};
</script>
<style scoped>
.copyright-outer {
  position: absolute;
  bottom: 0;
  padding: 15px 26px 10px 29px;
  width: 100%;
  background: #1565C0 0% 0% no-repeat padding-box;
}

.copyright-outer .copyright-inner {
  text-align: center;
}
.custom-scrollbar {
  overflow-y: auto;
  scrollbar-width: thin;         /* Firefox */
  scrollbar-color: #888 transparent;
  margin-bottom: 50px;
}
</style>
